import { useCallback, useState } from "react";
export const useAsyncAction = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const run = useCallback(async (action) => {
        setLoading(true);
        setError("");
        try {
            return await action();
        }
        catch (e) {
            setError(e instanceof Error ? e.message : "Unknown error");
            return null;
        }
        finally {
            setLoading(false);
        }
    }, []);
    return { loading, error, setError, run };
};
